import { type Dispatch, type SetStateAction, useCallback, useMemo } from 'react';
import type { FormSegment } from '../../../../../../../../../../modules/audiences/AudienceForm/types.ts';

export const useDistrictSelection = (value: FormSegment[], onChange: Dispatch<SetStateAction<FormSegment[]>>) => {
  const selected = useMemo(() => {
    const ids = new Set<string>();
    value.forEach(segment => {
      ids.add(segment.id);
    });

    return ids;
  }, [value]);

  const handleSelectDistrict = useCallback(
    (district: FormSegment) => {
      onChange(prev => {
        if (selected.has(district.id)) {
          return prev.filter(s => s.id !== district.id);
        }

        return [...prev, district];
      });
    },
    [onChange, selected]
  );

  return { selected, handleSelectDistrict };
};
